import { render, staticRenderFns } from "./PatientCaregiverDataForm.vue?vue&type=template&id=5ca496fe&"
import script from "./PatientCaregiverDataForm.vue?vue&type=script&lang=js&"
export * from "./PatientCaregiverDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports